import Styles from '../../../../Styles';
import Localized from 'src/constants/AppStrings';
import AramarkNoBlockedUser from 'src/components/img/svg/aramarkNoBlockedUser';
import {Platform} from 'react-native';

export function getItemContainerStyle(): {[key: string]: any} {
  return {
    blockedName: {
      fontSize: Styles.Fonts.f1,
      alignSelf: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
      fontWeight: '700',
      color: '#111111',
      flex: 1,
    },
    itemContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: Styles.Spacing.m3 - 3,
      borderBottomColor: Styles.dividerColor,
      borderWidth: 1,
      borderColor: Styles.inputBgColor,
      borderBottomWidth: 1,
    },
    nocardsContainer: {
      width: 300,
      height: 450,
      marginVertical: 'auto',
      padding: 90,
      top: 70,
      ...(Platform.OS === 'web' && {
        alignSelf: 'center',
      }),
    },
  };
}

export function getBlockedUserTitle() {
  return Localized.Labels.blocked_users;
}

export function blockedUsersEmptyIcon(): JSX.Element {
  return <AramarkNoBlockedUser />;
}

export function getUnBlockUserStyle(): {[key: string]: any} {
  return {
    btnUnblock: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.primary,
    },
    color: Styles.Colors.Aramark.primary,
    btnUnblockContainer: {
      paddingTop: 4,
      paddingBottom: 4,
      paddingHorizontal: 10,
      borderTopColor: Styles.Colors.Aramark.primary,
      borderBottomColor: Styles.Colors.Aramark.primary,
      borderLeftColor: Styles.Colors.Aramark.primary,
      borderRightColor: Styles.Colors.Aramark.primary,
      borderWidth: 2,
      overflow: 'hidden',
      borderColor: Styles.Colors.Aramark.primary,
    },
  };
}

export function getNoBlockedUsers(): {[key: string]: any} {
  return {
    noCardsContainer: {},
  };
}

export function getBlockedUsersList(): {[key: string]: unknown} {
  return {
    listWrapper: {
      backgroundColor: '#fff',
      borderWidth: 1.5,
      borderBottomWidth: 1.5,
      borderRadius: 8,
      overflow: 'hidden',
      margin: 16,
      marginTop: 32,
      borderColor: '#EAEAEB',
    },
    listStyle: {
      flex: 1,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      borderBottomColor: '#EAEAEB',
      borderColor: '#EAEAEB',
      borderLeftColor: '#EAEAEB',
      borderRightColor: '#EAEAEB',
      borderTopColor: '#EAEAEB',
      borderStartColor: '#EAEAEB',
      borderEndColor: '#EAEAEB',
      borderRadius: 10,
    },
  };
}

export default {
  getItemContainerStyle,
  getUnBlockUserStyle,
  getBlockedUsersList,
  getBlockedUserTitle,
  blockedUsersEmptyIcon,
};
